import styled from 'styled-components';
import { COLORS, pickThemeFontStyles } from '@/theme';
import { Button } from '@/ui';

export const StyledTableCard = styled.div.attrs({
  'data-pdf-block': 'true',
  'data-pdf-order': '3',
})`
  background: ${COLORS.WHITE};
  border: 1px solid ${COLORS.BRIGHT_GRAY};
  border-radius: 0.75rem;
  padding: 1rem 1rem 0.75rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  min-height: 100%;
  min-width: 0;
  width: 100%;
  overflow: hidden;

  [data-pdf-exporting='true'] & {
    min-height: 0;
    height: auto;
    width: 100%;
    overflow: visible;

    .ant-table-wrapper,
    .ant-table,
    .ant-table-container,
    .ant-table-content,
    .ant-table-body {
      overflow: visible !important;
      width: 100% !important;
      max-width: none !important;
    }

    .ant-table-cell {
      min-width: 0 !important;
      overflow: visible;
      white-space: normal !important;
      text-overflow: clip !important;
    }
  }

  .ant-table-wrapper {
    min-width: 0;
    overflow-x: visible;
  }

  .ant-table {
    min-width: 0;
    width: 100%;
    table-layout: fixed;
  }

  .ant-table-thead > tr > th:first-child,
  .ant-table-tbody > tr > td:first-child {
    padding-inline: 0.35rem !important;
    width: 2rem;
    max-width: 2rem;
  }

  .ant-table-cell {
    min-width: 0 !important;
    overflow: hidden;
  }

  .ant-table-cell:nth-child(2) {
    white-space: normal;
    word-break: break-word;
  }

  .ant-table-thead > tr > th:nth-child(3),
  .ant-table-tbody > tr > td:nth-child(3) {
    width: 152px;
    min-width: 152px;
    max-width: 152px;
    white-space: normal;
    word-break: normal;
    overflow-wrap: normal;
    hyphens: none;
    line-height: 1.25;
  }

  .ant-table-thead > tr > th:nth-child(4),
  .ant-table-tbody > tr > td:nth-child(4) {
    width: 112px;
    min-width: 112px;
    max-width: 112px;
    white-space: nowrap;
  }
`;

export const StyledTableTitle = styled.h3`
  margin: 0;
  ${pickThemeFontStyles('16', '22', 'SEMI_BOLD')};
`;

export const StyledFooterButton = styled(Button).attrs({ className: 'no-print' })`
  align-self: flex-start;
  margin-top: auto;
`;
